import { useEffect } from 'react';

import { useConsentStore } from '../../stores/consentStore';
import {
  analyticsConfigured,
  disableAnalytics,
  enableAnalytics,
  initAnalytics,
} from '../../lib/analytics/ga';

/**
 * Wires Google Analytics 4 to the analytics consent flag (#256). Boots GA4 in
 * Consent Mode (storage denied) on mount, then loads the library + grants
 * storage when the user opts into analytics, and revokes storage if they opt
 * out. Renders nothing. No-op when `VITE_GA_MEASUREMENT_ID` is unset.
 *
 * Consent gating is non-negotiable (CLAUDE.md rule 1, spec §10.7): GA is never
 * loaded for a visitor who hasn't granted analytics consent (default-deny).
 */
export function GoogleAnalytics() {
  const analytics = useConsentStore((s) => s.analytics);

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (!analyticsConfigured) return;
    if (analytics) enableAnalytics();
    else disableAnalytics();
  }, [analytics]);

  return null;
}

export default GoogleAnalytics;
